import React from 'react';

type Card = {
    title: string;
    img: string;
    description?: string;
    hoverInfo?: boolean;
};

const cards: Card[] = [
    {
        title: 'Education',
        img: '/jeevan-jyoti-ngo/images/areaofwork/demoimage.png',
        description:
            'We support access to quality education, scholarships, and learning tools that empower children to thrive.',
        hoverInfo: true,
    },
    {
        title: 'Loan',
        img: '/jeevan-jyoti-ngo/images/areaofwork/demoimage.png',
        description:
            'We support access to quality education, scholarships, and learning tools that empower children to thrive.',
        hoverInfo: true,
    },
    {
        title: 'Social Justice',
        img: '/jeevan-jyoti-ngo/images/areaofwork/demoimage.png',
        description:
            'We support access to quality education, scholarships, and learning tools that empower children to thrive.',
        hoverInfo: true,
    },
    {
        title: 'Product',
        img: '/jeevan-jyoti-ngo/images/areaofwork/demoimage.png',
        description:
            'We support access to quality education, scholarships, and learning tools that empower children to thrive.',
        hoverInfo: true,
    },
    {
        title: 'Health Care',
        img: '/jeevan-jyoti-ngo/images/areaofwork/demoimage.png',
        description:
            'We support access to quality education, scholarships, and learning tools that empower children to thrive.',
        hoverInfo: true,
    },
    {
        title: 'Donation',
        img: '/jeevan-jyoti-ngo/images/areaofwork/demoimage.png',
        description:
            'We support access to quality education, scholarships, and learning tools that empower children to thrive.',
        hoverInfo: true,
    },
];

const AreaOfWork: React.FC = () => {
    return (
        <section className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12">
            <div className="text-center">
                <div className="text-xs tracking-widest text-teal-700 font-semibold">AREA OF WORK</div>
                <h3 className="mt-2 text-2xl md:text-3xl font-semibold">Jeevan Jyoti Foundation</h3>
                <p className="mt-2 text-sm md:text-base text-gray-600">
                    NGO work encompasses a wide range of activities aimed at addressing social, environmental,
                    and humanitarian issues.
                </p>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
                {cards.map((c) => (
                    <div key={c.title} className="group rounded-xl overflow-hidden shadow ring-1 ring-gray-100">
                        <div className="relative">
                            <img src={c.img} alt={c.title} className="w-full h-60 object-cover" />
                            {c.hoverInfo && c.description && (
                                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center p-4">
                                    <p className="text-white text-sm md:text-base leading-relaxed text-center max-w-xs">
                                        {c.description}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="p-4">
                            <div className="w-full">
                                <span className="inline-block w-full text-center bg-[#0a5fa6] text-white font-medium rounded-md py-2">
                                    {c.title}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default AreaOfWork;
